import { RangeSlider } from './Range-Slider';
import { Dropdown } from './Dropdown';

// eslint-disable-next-line import/no-cycle
import { Request } from './Request';
import { EVENT_FILTER_APPLIED, EVENT_LAB_SLIDER_INIT } from '../../services/event-bus/event-types';
import {
    EVENT_APPLY_FILTER_STRING,
    EVENT_RESET_FILTER,
    FIND_LAB_BY_BREW,
} from '../../constants';

const { eventBus } = window.specialtyApp;

const WEIGHT_FILTER_ID = 755;
const COUNT_IN_BOX_FILTER_ID = 765;

/**
 * Ид фильтра кофе в о всяких упаковках (дрип-пакеты, капсулы, наборы), для которых неактуален фильтр "вес пачки"
 * @type {string[]}
 */
const BOXED_COFFEE_IDS = ['type_72', 'type_220', 'type_225'];
/**
 * Ид фильтра "кофе в зернах", для которых неактуален фильтр "кол-во в упаковке"
 * @type {string[]}
 */
const BEANS_COFFEE_IDS = ['type_71'];

let eventBusInitialized = false;

export class SmartFilter {
    constructor(filterElement) {
        this.filter = filterElement;
        if (!this.filter) return;

        this.AJAX = new Request();

        this.filterSearch = document.getElementById('filter-search');

        this.adaptiveOpenButton = document.querySelector(
            '.catalog__filter-button',
        );
        this.adaptiveCloseButton = this.filter.parentElement.querySelector(
            '.filter-handlers__close-button',
        );

        this.collapseTitles = Array.from(document.querySelectorAll(
            '.filter-element .filter-element__collapse-title',
        ));
        this.dropdowns = Array.from(
            this.filter.querySelectorAll('.filter-dropdown'),
        );
        this.ranges = Array.from(
            this.filter.querySelectorAll('.filter-dropdown[data-range]'),
        );

        const checkboxes = Array.from(
            this.filter.querySelectorAll('[type="checkbox"]'),
        );
        const radios = Array.from(
            this.filter.querySelectorAll('[type="radio"]'),
        );
        this.filterHandlers = [...checkboxes, ...radios];

        this.customSelects = this.filter.querySelectorAll('.custom-select-wrapper');

        this.submitButton = this.filter.querySelector('#set_filter');
        this.resetButtons = Array.from(
            this.filter.parentElement.querySelectorAll('[data-reset-filter]'),
        );

        this.SELECTOR_TOOLTIP_INSERTION = '[data-moveable-submit]'; // кнопка-всплывашка "Применить фильтр" на элементах смартфильтра
        this.SELECTOR_SUBMIT_TOOLTIP = 'filter-element__submit-tooltip';
        this.SELECTOR_SUBMIT_TOOLTIP_ACTIVE = 'filter-element__submit-tooltip--show';

        this.TOOLTIP_TIMER = null;
        this.TOOLTIP_TIMEOUT = 5000;

        this.TOTAL_ACTIVE_FILTERS = 0;
        this.isSliderInit = false;

        this.init();
        this.countActiveCheckboxesInElement();
        this.renderTotalActiveFiltersCount();

        this.filter.addEventListener('submit', (evt) => {
            evt.preventDefault();
        });

        if (!$(this.filter).hasClass('js-init-relations')) this.initRelations();
    }

    init() {
        this.checkboxClickHandler();
        this.setMoveableSubmit();
        this.checkSearchParams();
        this.firstLetterUppercase();
        this.initDropdown();
        this.initRange();
        this.submitButtonHandlers();
        this.resetButtonsHandlers();

        this.initTagsRender();
        this.initControlsButtons();
        this.initMobileCollapse();
        this.initSelectHandlers();

        this.initTagsHandler();
        this.initBrewingType();
        this.initEventBusEvents();
        this.initRegionsVisibility();
    }

    initEventBusEvents() {
        if (!eventBusInitialized) {
            eventBus.$on(EVENT_RESET_FILTER, this.resetFilter);
            eventBus.$on(EVENT_APPLY_FILTER_STRING, this.applyRequestString);
            eventBus.$on(EVENT_LAB_SLIDER_INIT, () => { this.isSliderInit = true; });
            eventBusInitialized = true;
        }
    }

    brewingChangeHandler = (event) => {
        // Логика (отработает только при наличии слайдера !!! )
        // 1. Выбираем метод заваривания
        // 2. Идём с методом заваривания (brew) в слайдер (если он есть вообще ?)
        // 3. Там по brew ищем среди лабораторий первое совпадение
        // 4. Если такое совпадение есть, то берем из лабы строку LAB_FILTER_COFFEE_QUERY
        // 5. Эту сроку эммитим из компонента сюда (EVENT_APPLY_FILTER_STRING), и делаем запрос по ней
        // 6. Если строка пустая -- делаем запрос на основе value метода заваривания (через эммит из компонента)

        const requestString = $(event.target).val();
        const brewValue = $(event.target).data('brewValue');

        if (!requestString) return;

        if (this.isSliderInit) {
            eventBus.$emit(FIND_LAB_BY_BREW, { brewValue, requestString });
        } else {
            this.applyRequestString(requestString);
        }
    }

    /**
     *
     * @param {String} queryString - запрос, который хотим отправить
     * @return {String} - совпали или нет
     */
    removeQueryFromFilter(queryString) {
        const queryParams = new URLSearchParams(queryString);
        const filterFormData = this.prepareFilterData(true);

        const result = new FormData();

        filterFormData.forEach((value, key) => {
            if (!queryParams.get(key) && value) {
                result.append(key, value);
            }
        });

        result.delete('brewing_type');

        return new URLSearchParams(result).toString();
    }

    applyRequestString = (requestString) => {
        const queryString = this.clearEmptyBrew(requestString);
        this.requestSimple(`?${queryString}`);
    }

    getFormDataFromReqString = (requestString) => {
        const params = new URLSearchParams(requestString);
        const query = new FormData();

        params.forEach((value, key) => {
            query.append(key, value);
        });

        return query;
    }

    initBrewingType = () => {
        const filterInputs = $('[data-brewing-filter]');
        const filterWrapper = $('[data-brewing-type]');

        filterInputs.on('change', this.brewingChangeHandler);

        filterWrapper.on('click', '.radio-input__label', (event) => {
            const $input = $(event.target).prev('input');

            if ($input.prop('checked')) {
                // TODO:
                // Не сбрасываем фильтр, делаем запрос
                // Проверяем все checked параметры в фильтре
                // И вычитаем из них параметры из value метода заваривания
                // Из этого делаем запрос и шлём на бек
                // Это и будет отключение метода заваривания

                // TODO: ... код ниже (закомментирован) отрабатывает не корректно
                // Сброс фильтра посредством отмены значений и запроса (что-то не то...)
                const query = this.removeQueryFromFilter($input.val());

                setTimeout(() => {
                    // eslint-disable-next-line no-param-reassign,no-return-assign
                    this.filterHandlers.forEach((element) => element.checked = false);
                    this.reinitRange();

                    this.applyRequestString(query);
                    // this.requestSimple(query);
                }, 0);

                // setTimeout(this.resetFilter, 0);
            }
        });
    }

    initControlsButtons() {
        if (!this.adaptiveOpenButton && !this.adaptiveCloseButton) return;

        this.adaptiveOpenButton.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.openAdaptiveMenu();
        });

        this.adaptiveCloseButton.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.closeAdaptiveMenu();
        });
    }

    initMobileCollapse() {
        this.collapseTitles.forEach((element) => {
            if (window.innerWidth <= 576) {
                $(element.dataset.target)
                    .collapse('hide');
            }
        });
    }

    // добавление тегов до отправки формы, при изменении инпутов
    initTagsRender() {
        const inputs = [...this.filterHandlers, ...this.ranges];
        inputs.forEach((element) => {
            element.addEventListener('change', () => {
                const filterElement = element.closest('.filter-element');

                if (!filterElement) return;

                this.countActiveCheckboxes(filterElement);
            });
        });

        this.collapseTitles.forEach((element) => {
            const collapsedElement = element.dataset.target;
            const filterElement = element.closest('.filter-element');

            if (window.innerWidth <= 576) {
                $(collapsedElement)
                    .on('hide.bs.collapse', () => {
                        $(filterElement.querySelector(
                            '.filter-element__checkbox-tags',
                        ))
                            .show();
                    });

                $(collapsedElement)
                    .on('show.bs.collapse', () => {
                        $(filterElement.querySelector(
                            '.filter-element__checkbox-tags',
                        ))
                            .hide();
                    });
            }
        });
    }

    initDropdown() {
        this.dropdowns.forEach((element) => new Dropdown(element));
    }

    initRange() {
        this.ranges.forEach((element) => {
            // eslint-disable-next-line no-new,no-unused-vars
            const range = new RangeSlider(element);
            element.addEventListener('change', () => {
                this.hideAllMoveableSubmit();
                this.showMoveableSubmit(element);
            });
        });
    }

    reinitRange() {
        this.ranges.forEach((element) => {
            RangeSlider.destroy(element);
            // eslint-disable-next-line no-new
            new RangeSlider(element);
        });
    }

    resetFilter = () => {
        const query = this.resetFilterData();
        this.requestSimple(query);
    }

    resetButtonsHandlers() {
        this.resetButtons.forEach((button) => {
            button.addEventListener('click', (evt) => {
                evt.preventDefault();

                this.resetFilter();
            });
        });
    }

    submitButtonHandlers() {
        if (!this.submitButton) return;

        this.submitButton.addEventListener('click', (evt) => {
            evt.preventDefault();

            const query = this.prepareFilterData();
            this.request(query);
        });
    }

    clearSearch() {
        if (!this.filterSearch) return;

        const searchInput = this.filterSearch.querySelector(
            'input[name="query"]',
        );
        if (!searchInput) return;

        if (searchInput.value) {
            searchInput.value = '';
            window.history.pushState({}, document.title, './');
            eventBus.$emit(EVENT_FILTER_APPLIED);
        }
    }

    clearEmptyBrew = (queryString) => {
        const searchParams = new URLSearchParams(queryString);
        const brewId = searchParams.get('brew');
        if (brewId) searchParams.set('brew', brewId);

        return searchParams.toString();
    }

    removeEmptyFormDataFields = (formData) => {
        const emptyFields = ['brewing_type'];

        // исключаем странное поведение при пустых MIN MAX свойствах

        if (formData) {
            formData.forEach((value, key) => {
                if (!value) {
                    emptyFields.push(key);
                }
            });
        }

        emptyFields.forEach((field) => formData.delete(field));
        return formData;
    };

    resetFilterData() {
        // eslint-disable-next-line no-param-reassign,no-return-assign
        this.filterHandlers.forEach((element) => element.checked = false);
        this.reinitRange();

        const query = new FormData();
        query.append('del_filter', 'y'); // параметр для сброса фильтра
        return `?${new URLSearchParams(query).toString()}`;
    }

    prepareFilterData(setFilter = true) {
        const query = new FormData(this.filter);

        if (setFilter) {
            query.append('set_filter', 'Y'); // параметр для показа фильтра
        }

        return query;
    }

    async request(query = new FormData()) {
        const formData = this.removeEmptyFormDataFields(query);
        this.clearSearch(); // поисковая строка

        this.closeAdaptiveMenu();
        await this.AJAX.request(formData);

        this.TOTAL_ACTIVE_FILTERS = 0;
        this.countActiveCheckboxesInElement();
        this.renderTotalActiveFiltersCount();
    }

    async requestSimple(queryString) {
        this.clearSearch(); // поисковая строка

        this.closeAdaptiveMenu();
        await this.AJAX.requestSimple(queryString);

        this.TOTAL_ACTIVE_FILTERS = 0;
        this.countActiveCheckboxesInElement();
        this.renderTotalActiveFiltersCount();
    }

    /**
     * В адаптиве прописывает активные теги для выбранного фильтра
     * @param filterElement
     * @param checkedCheckboxes
     */
    renderActiveTags = (filterElement, checkedCheckboxes) => {
        const tagsWrap = filterElement.querySelector('.filter-element__checkbox-tags');
        if (!tagsWrap) return;

        tagsWrap.textContent = '';

        checkedCheckboxes.forEach((inputElement) => {
            const checkboxElement = inputElement.parentElement.querySelector(
                '.checkbox-input__label, .radio-button__label, .radio-input__label',
            );
            if (!checkboxElement) return;

            const tag = document.createElement('div');
            tag.classList.add('checkbox-tag');
            tag.textContent = checkboxElement.textContent;

            tag.addEventListener('click', (evt) => {
                evt.preventDefault();

                // Для методов заваривания (в частности, для адаптива)
                if (inputElement.type === 'radio' && inputElement.closest('[data-brewing-type')) {
                    const radioWrapper = inputElement.closest('.radio-input__wrapper');
                    const radioLabel = radioWrapper ? radioWrapper.querySelector('.radio-input__label') : null;

                    if (radioLabel) radioLabel.click();
                } else {
                    inputElement.click();
                }

                if (tagsWrap.contains(tag)) {
                    tagsWrap.removeChild(tag);
                }
            });

            tagsWrap.appendChild(tag);
        });
    };

    renderRangeTags = (filterElement, { minInput, maxInput }) => {
        const tagsWrap = filterElement.querySelector('.filter-element__checkbox-tags');
        if (!tagsWrap) return;

        tagsWrap.textContent = '';

        if (!minInput && !maxInput) return;

        const values = {
            min: parseInt(minInput.value.replace(/\s/g, ''), 10),
            max: parseInt(maxInput.value.replace(/\s/g, ''), 10),
        };

        const suffix = filterElement.querySelector(
            '[data-suffix]',
        )?.dataset.suffix || '';

        if (values.max || values.min) {
            const tag = document.createElement('div');
            tag.classList.add('checkbox-tag');
            tag.textContent = `${values.min} - ${values.max}${suffix}`;

            tag.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.reinitRange();

                if (tagsWrap.contains(tag)) {
                    tagsWrap.removeChild(tag);
                }
            });

            tagsWrap.appendChild(tag);
        }
    };

    countActiveCheckboxes = (filterElement) => {
        const checkboxes = Array.from(
            filterElement.querySelectorAll('[data-for-count]'),
        );
        const checkedCheckboxes = checkboxes.filter((item) => item.checked);

        if (checkboxes.length) {
            const count = +checkedCheckboxes.length;
            const titleText = filterElement.querySelector('.filter-element__collapse-title span');

            const isBrewingType = filterElement.closest('.filter-element')?.querySelector('[data-brewing-type]');

            if (count && !isBrewingType) {
                titleText.dataset.activeCheckboxes = `(${count})`;
                this.TOTAL_ACTIVE_FILTERS += count;
            } else {
                titleText.removeAttribute('data-active-checkboxes');
            }

            this.renderActiveTags(filterElement, checkedCheckboxes);
            return;
        }

        const minInput = filterElement.querySelector('.price-min');
        const maxInput = filterElement.querySelector('.price-max');

        if (minInput && maxInput) {
            if (minInput.value || maxInput.value) {
                this.TOTAL_ACTIVE_FILTERS += 1;
            }

            this.renderRangeTags(filterElement, {
                minInput,
                maxInput,
            });
        }
    };

    countActiveCheckboxesInElement() {
        const filterElements = Array.from(
            this.filter.querySelectorAll('.filter-element'),
        );

        if (!filterElements.length) return;

        filterElements.forEach((element) => {
            this.countActiveCheckboxes(element);
        });
    }

    renderTotalActiveFiltersCount() {
        const catalogFilterButtons = Array.from(
            document.querySelectorAll('.catalog__filter-button'),
        );

        catalogFilterButtons.forEach((button) => {
            if (this.TOTAL_ACTIVE_FILTERS > 0) {
                button.classList.add('catalog__filter-button--active');
                button.setAttribute('data-total-count',
                    this.TOTAL_ACTIVE_FILTERS);
            } else {
                button.classList.remove('catalog__filter-button--active');
                button.removeAttribute('data-total-count');
            }
        });
    }

    openAdaptiveMenu = () => {
        const adaptiveMenu = document.getElementById('filter-menu-wrapper');
        if (!adaptiveMenu) return;

        adaptiveMenu.classList.add('smartfilter-wrapper--open');
        document.body.classList.add('page--filter-opened');
    }

    closeAdaptiveMenu = () => {
        const adaptiveMenu = document.getElementById('filter-menu-wrapper');
        if (!adaptiveMenu) return;

        adaptiveMenu.classList.remove('smartfilter-wrapper--open');
        document.body.classList.remove('page--filter-opened');
    }

    firstLetterUppercase() {
        const options = Array.from(
            this.filter.querySelectorAll('.checkbox-input__label'),
        );

        options.forEach((element) => {
            const text = element.textContent;
            // eslint-disable-next-line no-param-reassign
            element.textContent = text.charAt(0)
                .toUpperCase() + text.slice(1);
        });
    }

    checkSearchParams() {
        const formData = new FormData(this.filter);
        this.AJAX.setInitPreviousFormData(formData);
    }

    checkboxClickHandler() {
        this.filterHandlers.forEach((input) => {
            input.addEventListener('click', () => {
                // удаляем все тултипы
                this.hideAllMoveableSubmit();
                this.showMoveableSubmit(input);
            });
        });
    }

    createMoveableSubmit = (text = 'Показать товары') => {
        const button = document.createElement('button');
        button.name = 'set_filter';
        button.textContent = text;
        button.classList.add(this.SELECTOR_SUBMIT_TOOLTIP);

        button.addEventListener('click', (evt) => {
            evt.preventDefault();

            const formData = new FormData(this.filter);
            formData.append(button.name, 'Y');
            this.request(formData);

            this.hideAllMoveableSubmit();
        });

        return button;
    };

    showMoveableSubmit(element) {
        const moveable = element.closest(this.SELECTOR_TOOLTIP_INSERTION);
        if (!moveable) return;

        const button = moveable.querySelector(
            `.${this.SELECTOR_SUBMIT_TOOLTIP}`,
        );

        button.classList.add(this.SELECTOR_SUBMIT_TOOLTIP_ACTIVE);

        clearTimeout(this.TOOLTIP_TIMER);
        this.TOOLTIP_TIMER = setTimeout(
            () => button.classList.remove(this.SELECTOR_SUBMIT_TOOLTIP_ACTIVE),
            this.TOOLTIP_TIMEOUT,
        );
    }

    hideAllMoveableSubmit() {
        const buttons = Array.from(
            document.querySelectorAll(`.${this.SELECTOR_SUBMIT_TOOLTIP}`),
        );
        buttons.forEach((button) => button.classList.remove(
            this.SELECTOR_SUBMIT_TOOLTIP_ACTIVE,
        ));
    }

    setMoveableSubmit() {
        const parentElements = Array.from(
            document.querySelectorAll(this.SELECTOR_TOOLTIP_INSERTION),
        );

        parentElements.forEach((element) => {
            element.appendChild(this.createMoveableSubmit());
        });
    }

    getFilterElemById = (id) => $(`[data-filter-id='${id}']`)

    changeFilterState = (id, enable) => {
        const handler = enable ? 'removeClass' : 'addClass';
        const $filterElem = this.getFilterElemById(id);
        const inputs = $('input', $filterElem);

        $filterElem[handler]('filter-element--disable');

        if (!enable) {
            inputs.prop('checked', false);
        }
    };

    getCoffeeTypesState = () => {
        // кофе в зернах
        const coffeeInBeansChecked = BEANS_COFFEE_IDS.some(
            (name) => $(`[name='${name}']`)
                .prop('checked'),
        );

        const boxedCoffeeChecked = BOXED_COFFEE_IDS.some(
            (name) => $(`[name='${name}']`)
                .prop('checked'),
        );

        return { boxedCoffeeChecked, coffeeInBeansChecked };
    }

    handleRelationsFromCoffee = () => {
        const { coffeeInBeansChecked, boxedCoffeeChecked } = this.getCoffeeTypesState();

        if (coffeeInBeansChecked && boxedCoffeeChecked) {
            this.changeFilterState(COUNT_IN_BOX_FILTER_ID, true);
            this.changeFilterState(WEIGHT_FILTER_ID, true);
            return;
        }

        this.changeFilterState(COUNT_IN_BOX_FILTER_ID, !coffeeInBeansChecked);
        this.changeFilterState(WEIGHT_FILTER_ID, !boxedCoffeeChecked);
    };

    handlerRelationsFromParams = () => {
        const checkedWeight = $('input:checked', this.getFilterElemById(WEIGHT_FILTER_ID)).length;
        const checkedCountInBox = $('input:checked', this.getFilterElemById(COUNT_IN_BOX_FILTER_ID)).length;
        const coffeeTypesClean = Object.values(this.getCoffeeTypesState()).every((i) => !i);

        function toggleDisableInputs(arrNames, state) {
            arrNames.forEach((name) => {
                $(`[name='${name}']`).prop('disabled', state);
                if (state) $(`[name='${name}']`).prop('checked', false);
            });
        }

        toggleDisableInputs(BOXED_COFFEE_IDS, checkedWeight);
        toggleDisableInputs(BEANS_COFFEE_IDS, checkedCountInBox);

        if (coffeeTypesClean) {
            this.changeFilterState(COUNT_IN_BOX_FILTER_ID, !checkedWeight);
            this.changeFilterState(WEIGHT_FILTER_ID, !checkedCountInBox);
        }
    };

    handleRelationsInFilter = () => {
        this.handleRelationsFromCoffee();
        this.handlerRelationsFromParams();
        this.countActiveCheckboxesInElement();
    };

    initRelations = () => {
        this.handleRelationsInFilter();
        this.filter.addEventListener('change', this.handleRelationsInFilter);
        this.filter.classList.add('js-init-relations');
    }

    // Фильтр в обучении
    eventFilterRequest(deleleOption) {
        const query = this.prepareFilterData(false);

        // сброс фильтра в селекте
        [...query].forEach(([key, value]) => {
            if (+value === 0) {
                query.delete(key);
            }
        });

        if (deleleOption) {
            query.delete(deleleOption);
        }

        this.request(query);
    }

    initSelectHandlers = () => {
        $(this.customSelects).on('change', () => {
            this.eventFilterRequest();
        });
    };

    resetActiveTagClass = (tags, activeTag) => {
        tags.forEach((element) => {
            element.classList.remove('tag-handlers__item--select');
        });

        activeTag.classList.add('tag-handlers__item--select');
    };

    initTagsHandler = () => {
        const tags = Array.from(this.filter.querySelectorAll('.tag-handlers__item'));
        const tagsInputs = Array.from(this.filter.querySelectorAll('.tag-handlers__item input'));
        const resetTagsBtn = this.filter.querySelector('[data-reset-tags]');

        if (tagsInputs.length) {
            tagsInputs.forEach((tag) => {
                tag.addEventListener('change', () => {
                    this.eventFilterRequest();
                    this.resetActiveTagClass(tags, tag.closest('.tag-handlers__item'));
                });
            });
        }

        if (resetTagsBtn) {
            resetTagsBtn.addEventListener('click', (e) => {
                this.eventFilterRequest(e.target.dataset.resetTags);
                tagsInputs.forEach((tag) => {
                    // eslint-disable-next-line no-param-reassign
                    tag.checked = false;
                });
                this.resetActiveTagClass(tags, resetTagsBtn);
            });
        }
    };

    // Отображение регионов в зависимости от выбранной страны
    initRegionsVisibility = () => {
        const countriesCheckboxes = $('[data-country]');

        if (!countriesCheckboxes.length) return;

        const regionsCheckboxes = $('[data-country-in]');

        $(countriesCheckboxes).each((inedx, country) => {
            $(country).on('change', () => {
                this.toggleRegionsVisibility(countriesCheckboxes, regionsCheckboxes);
            });
        });

        this.toggleRegionsVisibility(countriesCheckboxes, regionsCheckboxes);
    };

    toggleRegionsVisibility = (countriesCheckboxes, regionsCheckboxes) => {
        const checkedCountries = $(countriesCheckboxes).filter(':checked');

        if (!checkedCountries.length) {
            $(regionsCheckboxes).addClass('visible-reg');
            return;
        }

        $(regionsCheckboxes).removeClass('visible-reg');

        $(checkedCountries).each((index, element) => {
            const countryId = $(element).data('country');
            $(regionsCheckboxes).filter(`[data-country-in="${countryId}"]`).addClass('visible-reg');
        });

        $(regionsCheckboxes).each((i, el) => {
            if (!$(el).hasClass('visible-reg')) {
                $(el).find('[type="checkbox"]').prop('checked', false).change();
            }
        });
    }
}
